import * as React from 'react';
import Proptypes from 'prop-types';
//MUI Components
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

function RadioButton(props) {
	return (
		<FormControl disabled={props.disabled}>
			<FormLabel id='demo-controlled-radio-buttons-group'>
				{props.label}
			</FormLabel>
			<RadioGroup
				row
				style={props.style}
				aria-labelledby='demo-controlled-radio-buttons-group'
				name={props.name}
				value={props.value}
				required
				onChange={(event) => props.onChange(event)}
			>
				{props.options.map((option) => (
					<FormControlLabel
						key={option.value}
						value={option.value}
						onChange={(event) => props.onChange(event)}
						control={<Radio />}
						label={option.label}
					/>
				))}
			</RadioGroup>
		</FormControl>
	);
}

RadioButton.propTypes = {
	label: Proptypes.string.isRequired, // label for the select input
	options: Proptypes.array.isRequired, // array of objects with value and label properties
	value: Proptypes.string.isRequired, // value of the select input
};

export default RadioButton;
